/* global femcare */

femcare.azure.auth = {
    init: function() {
        if ($('.azure-auth').not('.no-js').length) {
            this.initDatePicker();
            this.disableSubmitButton();
            this.createCheckboxes();
            this.initIntroText('.azure-signin', 'data-signin-intro');
            this.initIntroText('.azure-signup', 'data-signup-intro');
        } else {
            this.markRequiredFields();
        }
    },

    /**
     * Init custom and modify the Azure provided Date of birth field.
     */
    initDatePicker: function() {
        if ($('#extension_DOB').length) {
            var $signupContainer = $('.azure-signup'),
                yearPlaceholder = $signupContainer.data('date-year-placeholder'),
                monthPlaceholder = $signupContainer.data('date-month-placeholder'),
                dayPlaceholder = $signupContainer.data('date-day-placeholder'),
                dateFormat = $signupContainer.data('date-format'),
                dateLabel = $signupContainer.data('date-label');

            var dobLabel =
                '<div class="col-xs-12"><span class="form-date_label">' +
                dateLabel +
                '</span></div>';

            var dayLabel =
                '<label for="dob_day" class="form-label sr-only">' +
                dayPlaceholder +
                '</label>';
            var dayInput =
                '<input id="dob_day" class="form-control form-day" type="number" name="dob_day" ' +
                'data-validate="" min="1" max="31" placeholder="' +
                dayPlaceholder +
                '"></input>';
            var day =
                '<div class="form-group col-xs-12 col-sm-4">' +
                dayLabel +
                dayInput +
                '</div>';

            var monthLabel =
                '<label for="dob_month" class="form-label sr-only">' +
                monthPlaceholder +
                '</label>';
            var monthSelect =
                '<select id="dob_month" style="background-image: url(&quot/assets/img/system/dropdown-down.svg&quot)" class="form-control form-month select--placeholder" name="dob_month">' +
                '<option value="" selected disabled>' +
                monthPlaceholder +
                '</option>' +
                '<option value="1">1</option>' +
                '<option value="2">2</option>' +
                '<option value="3">3</option>' +
                '<option value="4">4</option>' +
                '<option value="5">5</option>' +
                '<option value="6">6</option>' +
                '<option value="7">7</option>' +
                '<option value="8">8</option>' +
                '<option value="9">9</option>' +
                '<option value="10">10</option>' +
                '<option value="11">11</option>' +
                '<option value="12">12</option>' +
                '</select>';
            var month =
                '<div class="form-group col-xs-12 col-sm-4">' +
                monthLabel +
                monthSelect +
                '</div>';

            var yearLabel =
                '<label for="dob_year" class="form-label sr-only">' +
                yearPlaceholder +
                '</label>';
            var yearInput =
                '<input id="dob_year" class="form-control form-year" type="number" placeholder="' +
                yearPlaceholder +
                '" min="1900" max="2020" name="dob_year" data-validate=""></input>';
            var year =
                '<div class="form-group col-xs-12 col-sm-4">' +
                yearLabel +
                yearInput +
                '</div>';

            var dobInput =
                '<input id="#extension_DOB" type="hidden" name="extension_DOB" value="">';

            var dateHtml =
                '<div class="form-date clearfix" data-format="' +
                dateFormat +
                '">' +
                dobLabel +
                day +
                month +
                year +
                dobInput +
                '</div>';

            $('label[for="extension_DOB"]').remove();
            $('#extension_DOB')
                .after(dateHtml)
                .remove();
        }
    },

    /**
     * Add and initialize checkbox fields to Azure sign-up.
     */
    createCheckboxes: function() {
        var $signupContainer = $('.azure-signup');
        if ($signupContainer.length) {
            var $submitButton = $('#continue');

            // Add terms and conditions checkbox
            var termsConditionsInputId = '#extension_Doubleoptin';
            var termsConditionsURL = $signupContainer.data('terms-conditions-url');
            var termsConditionsLabel = $signupContainer
                .data('terms-conditions')
                .replace('{terms-and-conditions-url}', termsConditionsURL);
            this.replaceTextBoxWithCheckBox(
                $(termsConditionsInputId),
                termsConditionsLabel,
                true
            );

            // Enable form submit button on terms accept
            $(termsConditionsInputId).on('change', function() {
                var checked = $(this).is(':checked');
                $submitButton
                    .prop('disabled', !checked)
                    .toggleClass('is-disabled', !checked);
            });

            // Add parental consent checkbox
            var parentalConsentInputId = '#extension_ParentalConsent';
            var parentalConsentLabel = $signupContainer.data('parental-consent-label');
            this.replaceTextBoxWithCheckBox(
                $(parentalConsentInputId),
                parentalConsentLabel,
                false
            );

            // Add newsletter subscribe checkbox
            var newsletterInputId = '#extension_Newsletteroptin';
            var $newsletterTextInput = $(newsletterInputId);
            var newsletterLabel = $signupContainer.data('signup-label');
            var newsletterLegal = $signupContainer.data('newsletter-legal');
            this.replaceTextBoxWithCheckBox($newsletterTextInput, newsletterLabel, false);

            var $newsletterCheckboxInput = $('#extension_Newsletteroptin');
            if ($newsletterCheckboxInput.length && newsletterLegal) {
                var newsletterLegalText =
                    '<div class="newsletter-legal"><p>' + newsletterLegal + '</p></div>';
                $newsletterCheckboxInput
                    .parent('.form-checkbox-control')
                    .append(newsletterLegalText);
            }
        }
    },

    /**
     * Replace the Azure signup form textbox field with a checkbox field and append it to the form.
     * @param {Object} $textBox - The textbox Jquery object to be replaced
     * @param {string} label - The label text for the checkbox
     * @param {boolean} isRequired - Indicates wheter checkbox is required
     */
    replaceTextBoxWithCheckBox: function($textBox, label, isRequired) {
        if ($textBox.length) {
            var inputId = $textBox.attr('id');

            $('label[for=' + inputId + ']').remove();

            var checkBoxHtml =
                '<input type="checkbox" value="true" id="' +
                inputId +
                '" name="' +
                inputId +
                '" ' +
                (isRequired ? 'required' : '') +
                '>';

            var labelHtml = '<label for="' + inputId + '">' + label + '</label>';

            var formField =
                '<div class="form-group form-group--checkbox"><div class="form-checkbox-control">' +
                checkBoxHtml +
                labelHtml +
                '</div></div>';

            $textBox.closest('.attrEntry').css('margin-bottom', 0);
            $textBox.after(formField).remove();
        }
    },

    /**
     * Disble submit button before terms and conditions is checked
     */
    disableSubmitButton: function() {
        var $submitButton = $('#continue');

        if ($submitButton.length && $('.azure-signup').length) {
            $submitButton.addClass('is-disabled');
        }
    },

    /**
     * Adding asterix to required fields
     */
    markRequiredFields: function() {
        var $signupContainer = $('.azure-signup');

        $signupContainer
            .find('input:required')
            .siblings('label')
            .addClass('azure-signup__required');
    },

    initIntroText: function(containerSelector, labelAttribute) {
        var $container = $(containerSelector);

        if ($container.length) {
            var $intro = $container.find('.intro');
            $intro.empty();

            var introText = $container.attr(labelAttribute);
            if (introText) {
                $intro.append('<p>' + introText + '</p>');
            }
        }
    }
};
